import { defineStyleConfig } from '@chakra-ui/react'
export const Text = defineStyleConfig({
  baseStyle: {
    color: '#F2F2F2',
    fontStyle: 'normal',
  },
})
